import { AppEnv } from '@/config/base'

export const BASE_URL = 'https://www.simscale.com'
export const API_BASE_URL = 'https://entrypoint.prod.simscale-platform.com'

export const LONG_URL = 'https://ws-long.simscale.com'

export const appEnv: AppEnv = AppEnv.PROD
export const REVALIDATE_TOKEN =
  'kopmjDCqU=zEUCnBA!2y7SM538280lMk8f2PMvPh6XJgLuOXacaAmtS8O?1dv=1SkT=YzwAwowKKiN=LZiEALDUrKjhu/TH2BVusKw9N4EVp==4ghqbJB8VEWiMjA0xm'
export const DISABLE_NEXT_IMAGE_OPTIMIZATION = false
